import {useEffect} from "react";
import {i18n} from "../maps/i18nMap";

function Tx(props) {
    useEffect(() => {
        if (Object.keys(zibi.languageMap).length === 0) {
            zibi.set_languageMap(i18n);
        }
    }, []);
    return (<span {...props}>{zibi.languageMap?.[zibi.language]?.map?.[props.children] || props.children}</span>);
}

export default Tx;